import { JsonLdSchemaHeader, JsonLdSchemaWebsite } from 'entities/Seo/config/JsonLdSchema';
import type { ICreateSchemaParams, ICreateSchemaOptions } from 'entities/Seo/types';

import { buildCollectionPageSchema } from './buildCollectionPageSchema';
import { mapBreadcrumbListToSchema } from './mapBreadcrumbListToSchema';
import { mapFAQtoSchema } from './mapFAQtoSchema';
import { mapMicrocreditsToProduct } from './mapMicrocreditsToProduct';

export function createSchema(params: ICreateSchemaParams, { product }: ICreateSchemaOptions): string {
  try {
    // if (!params?.microcredits?.items?.length && product) {
    //   return JSON.stringify(params.seo.schema);
    // }

    const hasMicrocredits = !!params?.microcredits?.items?.length;

    return JSON.stringify(
      [
        JsonLdSchemaHeader,
        JsonLdSchemaWebsite,
        buildCollectionPageSchema(params),
        mapBreadcrumbListToSchema(params),
        product && hasMicrocredits && mapMicrocreditsToProduct(params),
        mapFAQtoSchema(params),

        // offer && mapCardToSchema(params),
      ].filter((x) => !!x),
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err?.message, 'SeoSchema error parsing');

    return JSON.stringify([]);
  }
}
